<div mat-dialog-draggable-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
	<!--cdkDragHandle-->
	<a class="float-right btnClose" (click)="cerrarPopup()"><i class="fal fa-times" style="cursor: pointer;"></i></a>
	<a class="float-right btnClose" (click)="maximizarPopup()"><i class="fal fa-window-maximize"></i></a>
	<a class="float-right btnClose" (click)="minimizarPopup()"><i class="fal fa-window-minimize"></i></a>
	<div style="margin:0 auto; text-align: center;">
		<div class="matTitulo">
			<i class="fal fa-file-search" id="ico"></i>
			<h1 class="titulo" style="display:inline-block;">Histórico de Mediciones</h1>
		</div>
		<mat-divider></mat-divider>
	</div>
</div>
<mat-card class="mt-2">
	<mat-card-content class="card-content">
		<div class="row">
			<div class="col-md-12">
				<h4>Macromedidor de:&nbsp;{{descripcion.cliente}}</h4>
			</div>
			<div class="col-md-12">
				<span>Especifique un rango de tiempo en el cual desea generar la grafica.</span>
			</div>
		</div>
		<mat-divider class="mt-3"></mat-divider>
		<dx-validation-group #targetGroup>
			<div class="row mt-3">
				<div class="col col-sm-12 col-md-12 col-lg-12 mt-3">
					<div class="row">
						<div class="col col-sm-12 col-md-6 col-lg-6 mt-3">
							<div class="row">
								<button id="boton" type="submit" class="btn btn-success mt-3"
									(click)="obtenerReporteHoy()"><i class="fal fa-calendar-day"></i>Hoy</button>&nbsp;
								<button type="submit" class="btn btn-success mes-actual mt-3"
									(click)="obtenerReporteMes()"><i
										class="fal fa-calendar-alt"></i>{{mesActual.etiqueta}}</button>&nbsp;
								<button type="submit" class="btn btn-success mes-anterior mt-3"
									(click)="obtenerReporteMesAnterior()"><i
										class="fal fa-calendar-alt"></i>{{mesAnterior.etiqueta}}</button>&nbsp;
								<button type="submit" class="btn btn-success tres-meses mt-3"
									(click)="obtenerReporteTresMeses()"><i class="fas fa-calendar-minus"></i>3
									Meses</button>&nbsp;
								<button type="submit" class="btn btn-success anio mt-3" (click)="obteneReporteAnio()"><i
										class="fal fa-calendar"></i>{{anio}}</button>&nbsp;
							</div>
						</div>
						<div class="col col-sm-12 col-md-6 col-lg-6">
							<div class="row">
								<div class="col col-sm-12 col-md-4 col-lg-4">
									<label>Fecha Inicial:</label>
									<dx-date-box [(value)]="fechaInicio" type="datetime" style="width: 100%;"
										displayFormat="yyyy-MM-dd HH:mm:ss">
										<dx-validator>
											<dxi-validation-rule message="Campo requerido" type="required">
											</dxi-validation-rule>
										</dx-validator>
									</dx-date-box>
								</div>
								<div class="col col-sm-12 col-md-4 col-lg-4">
									<label>Fecha Final:</label>
									<dx-date-box [(value)]="fechaFin" style="width: 100%;" type="datetime"
										displayFormat="yyyy-MM-dd HH:mm:ss">
										<dx-validator>
											<dxi-validation-rule message="Campo requerido" type="required">
											</dxi-validation-rule>
										</dx-validator>
									</dx-date-box>
								</div>
								<div class="col col-sm-12 col-md-4 col-lg-4 mt-3">
									<button id="boton" type="submit" class="btn btn-success mt-3"
										(click)="reportePosicion(fechaInicio, fechaFin, 'rango')"><i
											class="fal fa-search"></i>Buscar</button>&nbsp;
								</div>
							</div>
						</div>

					</div>
				</div>
			</div>
		</dx-validation-group>
		<mat-divider class="mt-3"></mat-divider>
		<div id="grafica" class="row mt-3" *ngIf="showGrafica">
			<div class="col col-sm-12 col-md-12 col-lg-12 mt-3">
				<dx-tab-panel #tabPanel class="mt-3" [dataSource]="longtabs" [selectedIndex]="0" [loop]="false"
					[animationEnabled]="true" [swipeEnabled]="true" (onItemClick)="selectTab($event)">
					<div *dxTemplate="let grafica of 'title'">
						<span>{{grafica.titulo}}</span>
					</div>
					<div *dxTemplate="let grafica of 'item'">
						<div *ngIf="grafica.titulo === 'Gasto'" class="col col-sm-12 col-md-12 col-lg-12 mt-3">
							<div class="col col-sm-12 col-md-12 col-lg-12">
								<div class="row mt-3">
									<div class="col col-sm-12 col-md-4 col-lg-4 card-info">
										<div class="col col-md-12 card-info-title">
											<span>Lectura inicial</span>
										</div>
										<div class="col col-md-12 card-info-content">
											<div class="informacion">
												<span>{{gastoInicial}} m3</span>&nbsp;&nbsp;
												<span>{{fechaInicial}}</span>
											</div>
										</div>
									</div>
									<div class="col col-sm-12 col-md-4 col-lg-4 card-info">
										<div class="col col-md-12 card-info-title">
											<span>Gasto Promedio</span>
										</div>
										<div class="col col-md-12 card-info-content">
											<div class="informacion">
												<span>{{gastoPromedio}} m3</span>
											</div>
										</div>
									</div>
									<div class="col col-sm-12 col-md-4 col-lg-4 card-info">
										<div class="card-info-title">
											<span>Lectura final</span>
										</div>
										<div class="col col-md-12 card-info-content">
											<div class="informacion">
												<span>{{gastoFinal}} m3</span>&nbsp;&nbsp;
												<span>{{fechaFinal}}</span>
											</div>
										</div>
									</div>
								</div>
							</div>
							<dx-chart id="chart" class="mt-3" [dataSource]="dataSourceReportePosiciones">
								<dxi-series argumentField="fechaHora" valueField="gasto" name="Gasto" type="bar"
									color="#01a8fe">
								</dxi-series>
								<dxo-zoom-and-pan argumentAxis="both" valueAxis="pan"></dxo-zoom-and-pan>
								<dxo-tooltip [enabled]="true"></dxo-tooltip>
							</dx-chart>
						</div>
						<div *ngIf="grafica.titulo === 'Totalizador'" class="col col-sm-12 col-md-12 col-lg-12 mt-3">
							<div class="col col-sm-12 col-md-12 col-lg-12">
								<div class="row mt-3">
									<div class="col col-sm-12 col-md-6 col-lg-6 card-info">
										<div class="col col-md-12 card-info-title">
											<span>Lectura inicial</span>
										</div>
										<div class="col col-md-12 card-info-content">
											<div class="informacion">
												<span>{{totalizadorIncial}} m3</span>&nbsp;&nbsp;
												<span>{{fechaInicial}}</span>
											</div>
										</div>
									</div>
									<div class="col col-sm-12 col-md-6 col-lg-6 card-info">
										<div class="card-info-title">
											<span>Lectura final</span>
										</div>
										<div class="col col-md-12 card-info-content">
											<div class="informacion">
												<span>{{totalizadorFinal}} m3</span>&nbsp;&nbsp;
												<span>{{fechaFinal}}</span>
											</div>
										</div>
									</div>
								</div>
							</div>
							<dx-chart id="chart" class="mt-3" [dataSource]="dataSourceReportePosiciones">
								<dxi-series valueField="totalizador" name="Totalizador" color="#01a8fe"  argumentField="fechaHora" type="line">
								</dxi-series>
								<dxo-argument-axis [valueMarginsEnabled]="false" discreteAxisDivisionMode="crossLabels">
									<dxo-grid [visible]="true"></dxo-grid>
								</dxo-argument-axis>
								<dxo-zoom-and-pan argumentAxis="both" valueAxis="pan"></dxo-zoom-and-pan>
								<dxo-margin [bottom]="20"></dxo-margin>
								<dxo-tooltip [customizeTooltip]="customizeEtiqueta" [enabled]="true"></dxo-tooltip>
							</dx-chart>
						</div>
						<div *ngIf="grafica.titulo === 'General'" class="col col-sm-12 col-md-12 col-lg-12 mt-3">
							<dx-chart id="chart" class="mt-3" [dataSource]="dataSourceReportePosiciones">
								<dxi-series valueField="gasto" name="Gasto" color="#46be8a">
									<dxo-label [visible]="true" [customizeText]="customizeEtiqueta">
										<dxo-connector [visible]="true"></dxo-connector>
									</dxo-label>
								</dxi-series>
								<dxi-series  valueField="totalizador" name="Totalizador" color="#01a8fe">
									<dxo-label [visible]="true" [customizeText]="customizeEtiqueta">
										<dxo-connector [visible]="true"></dxo-connector>
									</dxo-label>
								</dxi-series>
								<dxo-common-series-settings argumentField="fechaHora" type="bar">
								</dxo-common-series-settings>
								<dxi-value-axis  [autoBreaksEnabled]="true"  [maxAutoBreakCount]="1">
									<dxi-break [startValue]="0" [endValue]="5000"></dxi-break>
								</dxi-value-axis>
								<dxo-argument-axis [visualRange]="visualRange">
								</dxo-argument-axis>
								<dxo-zoom-and-pan argumentAxis="both" valueAxis="pan"></dxo-zoom-and-pan>
							</dx-chart>
						</div>
					</div>
				</dx-tab-panel>
			</div>
		</div>
	</mat-card-content>
</mat-card>

<dx-load-panel #loadPanel shadingColor="rgba(0,0,0,0.4)" [position]="{ of: '#char-content' }"
	[(visible)]="loadingVisible" [showIndicator]="true" [showPane]="true" [shading]="true" [closeOnOutsideClick]="false"
	message="Cargando">
</dx-load-panel>
